module.exports = __webpack_public_path__ + "img/专利总数图标.43e138ac.png";